import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

@Injectable()
export class DatatransferService {


  constructor(private _http: HttpClient) { }


  public requestData(): Observable<any[]> {
    
    let arr_dev = [

  ];
    let api_string = "https://api.cognition.world/v1/sustainability/elec/external/dash/";
    
    let arr_api =[];
    
    for (let a of arr_dev) {
      let response;
      response = this._http.get(api_string+a);
      ////console.log(response,"response")
      arr_api.push(response)
    }
    
    ////console.log("previous service result",arr_api)
    return Observable.forkJoin(arr_api);

  }

  //Not in Use
  public requestData2(arr_dev: any[], apiToken: string): Observable<any[]> {
    
    let api_string = "https://api.cognition.world/v1/sustainability/elec/external/dash/";
    
    let arr_api =[];
    
    for (let a of arr_dev) {
      let response;
      response = this._http.get(api_string+a, {headers:{'Authorization': apiToken}});
      ////console.log(response,"response")
      arr_api.push(response)
    }
    
    ////console.log("previous service result",arr_api)
    return Observable.forkJoin(arr_api);

  }

  public requestData3(arr_dev: any[], apiToken: string): Observable<any[]> {
    // Electricity meter Devuis
    
    let api_string = "https://api.cognition.world/v1/sustainability/elecmeter/external/dash/";
    
    let arr_api =[];
    
    for (let a of arr_dev) {
      let response;
      response = this._http.get(api_string+a, {headers:{'Authorization': apiToken}});
      ////console.log(response,"response")
      arr_api.push(response)
    }
    
    return Observable.forkJoin(arr_api);

  }

} 



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard2/datatransfer.service.ts